import {PathUtility} from 'src/shared/constants/PathBuilder';

const isPublicUrl = (url: string) =>
  !url.toLocaleLowerCase().startsWith(PathUtility.Dashboard()) &&
  !url.toLocaleLowerCase().startsWith(PathUtility.Admin()) &&
  !url.toLocaleLowerCase().startsWith('/system') &&
  url !== '/' &&
  url !== '';

const isLoginUrl = (url = '/') =>
  url.toLocaleLowerCase() === PathUtility.Login();

const isLandingUrl = (url = '/') =>
  !!(url.toLocaleLowerCase() === PathUtility.Landing());

const isCreateAccountUrl = (url = '/') =>
  !!url.toLocaleLowerCase().includes(PathUtility.CreateAccount().slice(0, 16));

const showSharedPageElements = (
  isLoginURL: boolean,
  isLandingURL: boolean,
  isPublicURL: boolean,
  user: boolean,
  hasValidSession: boolean
) => {
  if (!user && isLoginURL) return false;
  if (isLandingURL) return true;
  if (isLoginURL) return false;
  if (isPublicURL) return true;
  if (hasValidSession) return true;
  return false;
};

export {
  isCreateAccountUrl,
  isLandingUrl,
  isLoginUrl,
  isPublicUrl,
  showSharedPageElements,
};
